export default {
    data() {
        return {
            validationFields: {},
            showValidationErrors: false,
            submitting: false,
        }
    },
    methods: {
        setValidated(event) {
            this.validationFields[event.fieldName] = event.value;
        },
        validate() {
            return !Object.values(this.validationFields).filter(validated => !validated).length;
        },
        handleSubmitErrors(errors) {
            errors.forEach((error) => {
                let keys = Object.keys(error);
                keys.forEach(key => {
                    let innerError = error[key];
                    let field = key;
                    let msg = typeof innerError === 'string'
                        ? innerError
                        : Object.values(innerError)[0];

                    this.vErrors.add({
                        field: field,
                        msg: msg
                    });
                })
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/Assets/components/Participants/Form/mixins/formValidationMixin.js